module.exports = __webpack_public_path__ + "img/square-silver-blank-small.0617bac0.png";